export default "__VITE_ASSET__dZFk6uiA__"